export default "__VITE_ASSET__51f89dcc__"